import React from 'react';
import { Button, Scroll, Tooltip } from 'next-common-lib';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { popupWriteForm } from '../../../lib/writeAppEmbed';
import './style.scss';
import { getFormAppOptions, openCenterWindow } from '../../lib/ultils';
import { useUser } from '../UserContext/UserProvider';

const displaySectionFields = ['tels', 'emails', 'addrs', 'urls', 'annivs', 'note', 'relation'];

const displaySectionNames = [
  'contacts.common.text.tel',
  'contacts.common.text.email',
  'contacts.common.text.addrInfoTable',
  'contacts.common.text.homepageInfoTable',
  'contacts.common.text.annivInfoTable',
  'contacts.common.text.note',
  'contacts.common.text.relationInfoTable',
];

const TYPE_MAP = {
  tels: [
    { label: 'contacts.common.text.compPhone.short', value: 'COMPANY' },
    { label: 'contacts.common.text.mobilePhone', value: 'MOBILE' },
    { label: 'contacts.common.text.home', value: 'HOME' },
    { label: 'contacts.common.text.fax', value: 'FAX' },
    { label: 'contacts.common.text.homeFax', value: 'HOME FAX' },
    { label: 'contacts.common.text.compFax', value: 'WORK FAX' },
    { label: 'contacts.common.text.etc', value: '' },
  ],
  emails: [
    { label: 'contacts.common.text.compEmail.short', value: 'COMPANY' },
    { label: 'contacts.common.text.persEmail.short', value: 'PERSONAL' },
    { label: 'contacts.common.text.etc', value: '' },
  ],
  urls: [
    { label: 'contacts.common.text.homepage', value: 'HOMEPAGE' },
    { label: 'contacts.common.text.blog', value: 'BLOG' },
    { label: 'contacts.common.text.sns', value: 'SNS' },
    { label: 'contacts.common.text.etc', value: '' },
  ],
  addrs: [
    { label: 'contacts.common.text.compAddr.short', value: 'COMPANY' },
    { label: 'contacts.common.text.homeAddr.short', value: 'HOME' },
    { label: 'contacts.common.text.etc', value: '' },
  ],
  annivs: [
    { label: 'contacts.common.text.birthday', value: 'BDAY' },
    { label: 'contacts.common.text.anniversary', value: 'ANNIVERSARY' },
  ],
};

const renderMethods = {
  addrs: data => {
    const fields = ['zip', 'addr', 'detailAddr', 'streetAddr', 'country', 'city', 'region'];
    return fields.reduce((rs, field) => {
      const val = data[field];
      if (val === undefined || val === null) return rs;
      return rs ? `${rs} ${val}` : val;
    }, '');
  },
  annivs: data => {
    const { date = '', lunarYn } = data;
    const dateStr = `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(6, 8)}`;
    const lunar = lunarYn === 'Y' ? ` (${i18next.t('contacts:contacts.common.text.lunar')})` : '';
    return `${dateStr} ${lunar}`;
  },
};

const shouldDisplayRep = componentType => {
  return componentType !== displaySectionFields[2];
};

const withTitle = (WrappedComponent, index) => {
  const { t } = useTranslation('contacts');
  return props => (
    <>
      <hr />
      <div className="form-group">
        <label htmlFor={displaySectionFields[index]}>{t(displaySectionNames[index])}</label>
        <WrappedComponent {...props} index={index} />
      </div>
    </>
  );
};

const LinkComponent = props => {
  const { componentType, val, priority } = props;

  const { t } = useTranslation('contacts');
  const user = useUser();

  const onClick = e => {
    e.preventDefault();
    if (componentType === 'tels') {
      openCenterWindow(`http://mysingle.wyz070.com/c2d.do?telephone=${val}`, 'callTelPopup', 324, 324);
    } else {
      const options = getFormAppOptions([props.contact], user);
      popupWriteForm(options);
    }
  };
  return (
    <>
      <span className="phone dial">
        <a href={`${componentType}:${val}`} onClick={onClick}>
          {val}
        </a>
      </span>
      {priority === 'YES' && shouldDisplayRep(componentType) && (
        <button type="button" className="pt-btn primary xxs btn-rep">
          <span className="text">{t('contacts.common.text.representative')}</span>
        </button>
      )}
    </>
  );
};

const DataSection = props => {
  const { index, data } = props;
  const componentType = displaySectionFields[index];
  const { t } = useTranslation('contacts');

  let content = null;
  if (Array.isArray(data)) {
    content =
      index !== displaySectionFields.length - 1 ? (
        <div className="tbl-list">
          <div className="tbl-body">
            {data.map((itemData, itemIndex) => {
              const { type, priority } = itemData;
              const renderMethod = renderMethods[componentType];
              const val = renderMethod ? renderMethod(itemData) : itemData.val;
              const currentType = TYPE_MAP[componentType]?.find(itemType => itemType.value === type);
              const displayType = currentType ? t(currentType.label) : type;

              return (
                <div className="tbl-row" key={itemIndex}>
                  <div className="cell" role="rowheader">
                    <div className="inner-row">
                      <strong className="title">{displayType}</strong>
                    </div>
                  </div>
                  <div className="cell">
                    <div className="inner-row">
                      {index < 2 ? (
                        <LinkComponent val={val} priority={priority} componentType={componentType} contact={data} />
                      ) : (
                        val
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="row">
          {data.map(itemData => {
            const { id, displayName } = itemData;
            return (
              <div className="chip-contact" key={id}>
                <span
                  className="photo"
                  style={{
                    backgroundImage: `url('/employee/empsearch/rest/v1/photo/tinythumb?epid=${id}')`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                  }}
                />
                <span className="text">{displayName.split('/')[0]}</span>
              </div>
            );
          })}
        </div>
      );
  } else if (typeof data === 'string') {
    content = <div className="row">{data}</div>;
  }

  return <>{content}</>;
};

const ContactProfileCardContent = props => {
  const { data, closeFunction } = props;
  const { t } = useTranslation('contacts');

  // const isGlobalLanguage = i18n.language === 'en';
  return (
    <section className="view-contents-container address preview-contact-popup-lib">
      <div className="view-body-contents">
        <div className="header-area">
          <div className="profile-area">
            <div className="img-input">
              {data.photo ? (
                <img className="img-input-wrapper" src={data.photo.split('^')[1]} alt="emp-avatar" />
              ) : (
                <div className="img-input-wrapper default" />
              )}
            </div>
            <div className="profile-info">
              <div className="row">
                <div className="item-left">
                  <Tooltip componentType="move" isShow title={data.fullName}>
                    <span className="name truncate">{data.fullName}</span>
                  </Tooltip>
                  <span className="nick">{data.nickName}</span>
                </div>
                {closeFunction && (
                  <div className="item-right">
                    <Button
                      componentType="etc"
                      iconInfo={{
                        className: 'ic-close sm',
                      }}
                      onClick={closeFunction}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <span className="position">{data.title}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="contents-body-area scroll-show">
          <div style={{ height: '100%', width: '100%', maxWidth: 'inherit', maxHeight: 'inherit', overflowY: 'auto' }}>
            <section className="address-lookup-wrap">
              <div className="form-group">
                <label htmlFor="company">{t('contacts.common.text.comp')}</label>
                <div className="tbl-list">
                  <div className="tbl-body">
                    <div className="tbl-row">
                      <div className="cell" role="rowheader">
                        <div className="inner-row">
                          <strong className="title">{t('contacts.common.text.dept')}</strong>
                        </div>
                      </div>
                      <div className="cell">
                        <div className="inner-row">{data.deptName}</div>
                      </div>
                    </div>
                    <div className="tbl-row">
                      <div className="cell" role="rowheader">
                        <div className="inner-row">
                          <strong className="title">{t('contacts.common.text.comp')}</strong>
                        </div>
                      </div>
                      <div className="cell">
                        <div className="inner-row">{data.compName}</div>
                      </div>
                    </div>
                    <div className="tbl-row">
                      <div className="cell" role="rowheader">
                        <div className="inner-row">
                          <strong className="title">{t('contacts.common.text.jobName')}</strong>
                        </div>
                      </div>
                      <div className="cell">
                        <div className="inner-row">{data.job}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {displaySectionFields.map((field, fieldIndex) => {
                const SectionItem = withTitle(DataSection, fieldIndex);
                return <SectionItem key={field} data={data[field]} />;
              })}
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactProfileCardContent;
